import * as addPanel from '@/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['add_section_heading_range_slider'],
      sections: [addPanel.sections.getSections().developer.rangeSliderSection],
    };
  },
};
